module.exports = __webpack_public_path__ + "static_pc/img/ba01.9795e175.png";